import { fetchV1 } from 'helpers/fetch.js';
import { toQueryString } from 'helpers/api.js';

export default {
  getCategoriesList(filter) {
    return fetchV1.get(`/categories?${toQueryString(filter)}`);
  },
  getBrandCategories(id, filters) {
    return fetchV1.get(`/brands/${id}/categories?${toQueryString(filters)}`);
  },
  getPublisherCategories(id, filters) {
    return fetchV1.get(`/publishers/${id}/categories?${toQueryString(filters)}`);
  },
  getCompetitorsCategories(filters) {
    return fetchV1.get(`/competitors_categories?${toQueryString(filters)}`);
  },
  getSubscribedCategories(filters) {
    return fetchV1.get(`/subscribed_categories?${toQueryString(filters)}`);
  },
  getBookmarkedCategories(filters) {
    return fetchV1.get(`/bookmarked_categories?${toQueryString(filters)}`);
  },
  getPartnershipCategories(brandId, publisherId, filters) {
    return fetchV1.get(`/brands/${brandId}/publishers/${publisherId}/categories?${toQueryString(filters)}`);
  },
  getHubsCategories(entityId, hubId, filters) {
    return fetchV1.get(`/brands/${entityId}/hubs/${hubId}/categories?${toQueryString(filters)}`);
  },
};
